













































































































// Vue
import { defineComponent, ref, Ref } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { DataTable } from '@/components/table'
import { Button } from '@/components/general'
import { FiltersWorkSheetsIndex } from '@/components/workSheets'

// Models
import { Paginator } from '@/models'
import { BiweeklyPayroll } from '@/models/payroll/PayrollTypes'

// utils
import { alerts, dateLibs, formatAmount } from '@/utils'
import { getTextWorkCategory } from '@/constants'

// services
import PayrollService from '@/services/payroll/PayrollService'

export default defineComponent({
  name: 'WorkSheetsIndex',
  components: {
    PageHeader,
    FiltersWorkSheetsIndex,
    DataTable,
    Button
  },
  methods: {
    isEditable (year: string, month: string): boolean {
      return parseInt(year) > 2023 || (parseInt(year) === 2023 && parseInt(month) > 4)
    }
  },
  setup (props, { root: { $router } }) {
    const router = $router
    const title = 'Planilla Quincenal'
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Planillas',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
      currentPage: 1,
      total: 0,
      count: 0,
      perPage: 25
    })
    const loading = ref(false)
    const filters: Ref<{year: string; month: string; fortnight: string; work_category: string }> = ref({
      year: '',
      month: '',
      fortnight: '',
      work_category: ''
    })
    const headers = [
      {
        key: 'year',
        sortable: true,
        label: 'Año'
      },
      {
        key: 'month',
        sortable: true,
        label: 'Mes',
        formatter: (value: number) => {
          return dateLibs.getMonthName(value)
        }
      },
      {
        key: 'fortnight',
        sortable: true,
        label: 'Quincena',
        formatter: (value: number) => {
          return dateLibs.getFortnightText(value)
        }
      },
      {
        key: 'work_category',
        sortable: true,
        label: 'Categoría Ocupacional',
        formatter: (value: number) => {
          return value ? getTextWorkCategory(value) : 'Todos'
        }
      },
      {
        key: 'total_to_pay',
        sortable: true,
        label: 'Total a Pagar',
        formatter: (value: number) => {
          return `S/. ${formatAmount(value)}`
        }
      },
      {
        key: 'actions',
        label: 'Acciones'
      }
    ]
    const payroll: Ref<BiweeklyPayroll[]> = ref([])
    const getPayroll = async () => {
      loading.value = true
      const payload = await PayrollService.getWithPagination(pagination.value.currentPage, pagination.value.perPage)
      payroll.value = payload.objects
      pagination.value = payload.pagination
      loading.value = false
    }
    getPayroll()

    const isFiltersValid = () => {
      if (!filters.value.year || !filters.value.month || !filters.value.fortnight) {
        return false
      }
      return true
    }
    const generate = () => {
      loading.value = true
      if (!isFiltersValid()) {
        loading.value = false
        return alerts.error('Debe completar todos los filtros')
      }
      loading.value = false
      return router.push({
        name: 'payroll',
        query: {
          ...filters.value
        }
      })
    }

    const deletePayroll = async (item: BiweeklyPayroll) => {
      const confirmed = await alerts.confirm('Seguro de eliminar la planilla seleccionada?')
      if (confirmed) {
        loading.value = true
        await PayrollService.delete(item.id)
        loading.value = false
        alerts.success()
        setTimeout(() => {
          getPayroll()
        }, 300)
      }
    }

    return {
      title,
      breadcrumbs,
      pagination,
      loading,
      headers,
      generate,
      filters,
      payroll,
      deletePayroll
    }
  }
})
